import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const TeamSettings = () => {
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteRole, setInviteRole] = useState('viewer');
  const [showInviteForm, setShowInviteForm] = useState(false);

  const teamMembers = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john.doe@appcreator.com',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1aef10a9f-1763294632369.png",
    avatarAlt: 'Professional headshot of Caucasian man with short brown hair wearing navy blue suit',
    role: 'owner',
    joinedDate: '2025-01-15',
    lastActive: '2025-12-26'
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    email: 'sarah.j@appcreator.com',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17cdc4ce1-1763297858042.png",
    avatarAlt: 'Professional headshot of African American woman with long black hair wearing white blouse',
    role: 'editor',
    joinedDate: '2025-02-20',
    lastActive: '2025-12-25'
  },
  {
    id: 3,
    name: 'Michael Chen',
    email: 'michael.chen@appcreator.com',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13a48293d-1763296098326.png",
    avatarAlt: 'Professional headshot of Asian man with short black hair wearing gray suit',
    role: 'editor',
    joinedDate: '2025-03-10',
    lastActive: '2025-12-24'
  },
  {
    id: 4,
    name: 'Emily Rodriguez',
    email: 'emily.r@appcreator.com',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9f45209-1763294258604.png",
    avatarAlt: 'Professional headshot of Hispanic woman with long brown hair wearing teal blazer',
    role: 'viewer',
    joinedDate: '2025-04-05',
    lastActive: '2025-12-23'
  }];


  const roleOptions = [
  { value: 'owner', label: 'Owner', description: 'Full access to all settings and can delete project' },
  { value: 'editor', label: 'Editor', description: 'Can edit content and manage integrations' },
  { value: 'viewer', label: 'Viewer', description: 'Can view project but cannot make changes' }];


  const getRoleBadgeColor = (role) => {
    switch (role) {
      case 'owner':
        return 'bg-primary/10 text-primary';
      case 'editor':
        return 'bg-accent/10 text-accent';
      case 'viewer':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const handleSendInvite = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    console.log('Sending invite to:', inviteEmail, 'with role:', inviteRole);
    setInviteEmail('');
    setShowInviteForm(false);
  };

  const handleRemoveMember = (memberId) => {
    console.log('Removing member:', memberId);
  };

  const handleChangeRole = (memberId, newRole) => {
    console.log('Changing role for member:', memberId, 'to:', newRole);
  };

  const handleResendInvite = (e, email) => {
    e?.preventDefault();
    e?.stopPropagation();
    console.log('Resending invitation to:', email);
  };

  const handleCancelInvite = (e, email) => {
    e?.preventDefault();
    e?.stopPropagation();
    console.log('Canceling invitation for:', email);
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
          <div>
            <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground">
              Team Members
            </h3>
            <p className="text-sm text-muted-foreground mt-1">
              Manage who has access to this project
            </p>
          </div>
          <Button
            variant="default"
            size="sm"
            iconName="UserPlus"
            iconPosition="left"
            onClick={(e) => {
              e?.preventDefault();
              e?.stopPropagation();
              setShowInviteForm(!showInviteForm);
            }}
            type="button">

            Invite Member
          </Button>
        </div>

        {showInviteForm &&
        <div className="mb-6 p-4 bg-muted rounded-lg space-y-4">
            <h4 className="caption font-medium text-foreground">Invite New Member</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
              label="Email Address"
              type="email"
              placeholder="colleague@company.com"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e?.target?.value)}
              required />

              <Select
              label="Role"
              options={roleOptions}
              value={inviteRole}
              onChange={setInviteRole} />

            </div>
            <div className="flex items-center gap-2">
              <Button
              variant="default"
              size="sm"
              onClick={handleSendInvite}
              disabled={!inviteEmail}
              iconName="Send"
              iconPosition="left"
              type="button">

                Send Invitation
              </Button>
              <Button
              variant="outline"
              size="sm"
              onClick={(e) => {
                e?.preventDefault();
                e?.stopPropagation();
                setShowInviteForm(false);
              }}
              type="button">

                Cancel
              </Button>
            </div>
          </div>
        }

        <div className="space-y-3">
          {teamMembers?.map((member) =>
          <div
            key={member?.id}
            className="p-4 bg-background border border-border rounded-lg hover:shadow-sm transition-all duration-250">

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <Image
                src={member?.avatar}
                alt={member?.avatarAlt}
                className="w-12 h-12 rounded-full object-cover flex-shrink-0" />

                
                <div className="flex-1 min-w-0">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-1">
                    <h4 className="caption font-semibold text-foreground">{member?.name}</h4>
                    <span className={`px-2 py-1 rounded text-xs font-medium capitalize ${getRoleBadgeColor(member?.role)}`}>
                      {member?.role}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">{member?.email}</p>
                  <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="Calendar" size={12} />
                      Joined {member?.joinedDate}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      Last active {member?.lastActive}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 w-full sm:w-auto">
                  {member?.role !== 'owner' &&
                <>
                      <Select
                    options={roleOptions?.filter((opt) => opt?.value !== 'owner')}
                    value={member?.role}
                    onChange={(value) => handleChangeRole(member?.id, value)}
                    className="flex-1 sm:flex-none sm:w-32" />

                      <Button
                    variant="destructive"
                    size="sm"
                    onClick={(e) => {
                      e?.preventDefault();
                      e?.stopPropagation();
                      handleRemoveMember(member?.id);
                    }}
                    iconName="Trash2"
                    type="button" />

                    </>
                }
                  {member?.role === 'owner' &&
                <span className="text-xs text-muted-foreground italic">Project Owner</span>
                }
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-4 md:mb-6">
          Role Permissions
        </h3>
        
        <div className="space-y-4">
          {roleOptions?.map((role) =>
          <div key={role?.value} className="p-4 bg-muted rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <div className={`px-3 py-1 rounded text-sm font-medium capitalize ${getRoleBadgeColor(role?.value)}`}>
                  {role?.label}
                </div>
              </div>
              <p className="text-sm text-muted-foreground mb-3">{role?.description}</p>
              
              <div className="space-y-2">
                <p className="text-xs font-medium text-foreground">Permissions:</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {role?.value === 'owner' &&
                <>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>Full project access</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>Manage team members</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>Delete project</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>Billing management</span>
                      </div>
                    </>
                }
                  {role?.value === 'editor' &&
                <>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>Edit content</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>Manage integrations</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>Deploy changes</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-muted-foreground">
                        <Icon name="X" size={14} className="text-destructive" />
                        <span>Delete project</span>
                      </div>
                    </>
                }
                  {role?.value === 'viewer' &&
                <>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>View project</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-foreground">
                        <Icon name="Check" size={14} className="text-success" />
                        <span>Export data</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-muted-foreground">
                        <Icon name="X" size={14} className="text-destructive" />
                        <span>Edit content</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-muted-foreground">
                        <Icon name="X" size={14} className="text-destructive" />
                        <span>Manage settings</span>
                      </div>
                    </>
                }
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-4 md:mb-6">
          Pending Invitations
        </h3>
        
        <div className="space-y-3">
          <div className="p-4 bg-background border border-border rounded-lg">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
              <div className="flex-1">
                <p className="caption font-medium text-foreground mb-1">alex.smith@company.com</p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <span className="px-2 py-1 rounded bg-accent/10 text-accent">Editor</span>
                  <span>Invited on Dec 20, 2025</span>
                </div>
              </div>
              <div className="flex items-center gap-2 w-full sm:w-auto">
                <Button 
                  variant="outline" 
                  size="sm" 
                  iconName="Send" 
                  iconPosition="left" 
                  className="flex-1 sm:flex-none"
                  onClick={(e) => handleResendInvite(e, 'alex.smith@company.com')}
                  type="button">
                  Resend
                </Button>
                <Button 
                  variant="destructive" 
                  size="sm" 
                  iconName="X" 
                  className="flex-1 sm:flex-none"
                  onClick={(e) => handleCancelInvite(e, 'alex.smith@company.com')}
                  type="button">
                  Cancel
                </Button>
              </div>
            </div>
          </div>

          <div className="text-center py-8 text-muted-foreground text-sm">
            <Icon name="Users" size={32} className="mx-auto mb-2 opacity-50" />
            <p>No other pending invitations</p>
          </div>
        </div>
      </div>
    </div>);

};

export default TeamSettings;